import { gql, useMutation } from '@apollo/client';

/* ============================================
   GRAPHQL MUTATION DEFINITIONS
   ============================================ */

// Rider login mutation.
const LOGIN_RIDER = gql`
  mutation LoginRider($email: EmailAddress!, $password: String!) {
    loginRider(input: { email: $email, password: $password }) {
      accessToken
      rider {
        id
        name
      }
    }
  }
`;

// Rider refresh Access Token using Refresh Token mutation.
const REFRESH_ACCESS_TOKEN_RIDER = gql`
  mutation RefreshAccessTokenRider {
    refreshAccessTokenRider {
      accessToken
      rider {
        id
        name
      }
    }
  }
`;

// Rider logout.
const LOGOUT_RIDER = gql`
  mutation LogoutRider {
    logoutRider {
      message
    }
  }
`;

// Rider signup mutation.
const SIGNUP_RIDER = gql`
  mutation SignupRider(
    $email: EmailAddress!
    $password: String!
    $name: String!
    $phoneNumber: String!
    $inviteCode: String
  ) {
    signupRider(
      input: {
        email: $email
        password: $password
        name: $name
        phoneNumber: $phoneNumber
        inviteCode: $inviteCode
      }
    ) {
      accessToken
      rider {
        id
        name
      }
    }
  }
`;

// Driver login mutation.
const LOGIN_DRIVER = gql`
  mutation LoginDriver($email: EmailAddress!, $password: String!) {
    loginDriver(input: { email: $email, password: $password }) {
      accessToken
      driver {
        id
        name
      }
    }
  }
`;

// Driver refresh Access Token using Refresh Token mutation.
const REFRESH_ACCESS_TOKEN_DRIVER = gql`
  mutation RefreshAccessTokenDriver {
    refreshAccessTokenDriver {
      accessToken
      driver {
        id
        name
      }
    }
  }
`;

// Driver logout.
const LOGOUT_DRIVER = gql`
  mutation LogoutDriver {
    logoutDriver {
      message
    }
  }
`;

/* ============================================
   MUTATION HOOKS
   ============================================ */

// Login rider
export const useLoginRider = () => {
  const [
    loginRider,
    {
      data: riderLoginData,
      loading: loadingRiderLogin,
      error: errorRiderLogin,
    },
  ] = useMutation(LOGIN_RIDER);

  return { loginRider, riderLoginData, loadingRiderLogin, errorRiderLogin };
};

// Refresh rider's access token
export const useRefreshAccessTokenRider = () => {
  const [
    refreshAccessTokenRider,
    {
      data: riderRefreshData,
      loading: loadingRefreshRider,
      error: errorRefreshRider,
    },
  ] = useMutation(REFRESH_ACCESS_TOKEN_RIDER);

  return {
    refreshAccessTokenRider,
    riderRefreshData,
    loadingRefreshRider,
    errorRefreshRider,
  };
};

// Logout rider
export const useLogoutRider = () => {
  const [
    logoutRider,
    {
      data: riderLogoutData,
      loading: loadingLogoutRider,
      error: errorLogoutRider,
    },
  ] = useMutation(LOGOUT_RIDER);

  return { logoutRider, riderLogoutData, loadingLogoutRider, errorLogoutRider };
};

// Signup rider
export const useSignupRider = () => {
  const [
    signupRider,
    {
      data: riderSignupData,
      loading: loadingRiderSignup,
      error: errorRiderSignup,
    },
  ] = useMutation(SIGNUP_RIDER);

  return { signupRider, riderSignupData, loadingRiderSignup, errorRiderSignup };
};

// Login driver
export const useLoginDriver = () => {
  const [
    loginDriver,
    {
      data: driverLoginData,
      loading: loadingLoginDriver,
      error: errorLoginDriver,
    },
  ] = useMutation(LOGIN_DRIVER);

  return { loginDriver, driverLoginData, loadingLoginDriver, errorLoginDriver };
};

// Refresh driver's access token
export const useRefreshAccessTokenDriver = () => {
  const [
    refreshAccessTokenDriver,
    {
      data: driverRefreshData,
      loading: loadingRefreshDriver,
      error: errorRefreshDriver,
    },
  ] = useMutation(REFRESH_ACCESS_TOKEN_DRIVER);

  return {
    refreshAccessTokenDriver,
    driverRefreshData,
    loadingRefreshDriver,
    errorRefreshDriver,
  };
};

// Logout driver
export const useLogoutDriver = () => {
  const [
    logoutDriver,
    {
      data: driverLogoutData,
      loading: loadingLogoutDriver,
      error: errorLogoutDriver,
    },
  ] = useMutation(LOGOUT_DRIVER);

  return {
    logoutDriver,
    driverLogoutData,
    loadingLogoutDriver,
    errorLogoutDriver,
  };
};
